import request from '@/utils/request'

export function getList (filters = {}, pagination = {}) {
  return request({
    url: '/site',
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination)
    }
  })
}

export function getDetail (id) {
  return request({
    url: '/site/' + id,
    method: 'get'
  })
}

export function upsert (data) {
  var method = 'post'
  var url = '/site'
  if (data.id) {
    method = 'put'
    url = '/site/' + data.id
  }
  return request({
    url,
    method,
    data
  })
}

export function remove (id) {
  return request({
    url: '/site/' + id,
    method: 'delete',
  })
}
